import { StateCreator, createStore } from 'zustand/vanilla';

import EventsHandler from '@/state/middlewares/events-handler';
import Logger from '@/state/middlewares/logger';
import type { Middleware } from '@/state/middlewares/typings';
import actionsCreator from '@/state/slices/actions';
import state from '@/state/slices/state';
import type { IStore } from '@/state/slices/typings';
import deepMerge from '@/utils/deep-merge';
import ExposerService from '@/utils/exposer';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service';

const storeCreator: StateCreator<IStore, [never, unknown][], [], IStore> = (
	set,
	get,
) => deepMerge(state, actionsCreator(set, get));

const applyMiddlewares = (
	middlewares: Middleware[],
	storeCreator: StateCreator<IStore, [never, unknown][], [], IStore>,
) => {
	return middlewares.reduce(
		(next, middleware) => middleware(next),
		storeCreator,
	);
};

const loggerDisabled = EnvVarsService.getVar('VITE_DISABLE_STATE_LOGGER', true);

const middlewares: (<T extends IStore>(
	config: StateCreator<T>,
) => StateCreator<T>)[] = [];

if (process.env.NODE_ENV === 'development' && !loggerDisabled)
	middlewares.push(Logger.middleware);
middlewares.push(EventsHandler.middleware);

const store = createStore<IStore, [never, unknown][]>(
	applyMiddlewares(middlewares, storeCreator),
);

ExposerService.expose('store', 'zustand', store);

export default store;
